import axios from "axios";
import router from "@/router";
import store from "@/store";
import { storeJWTToken, removeJWTToken } from "./auth";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "X-API-SECRET": process.env.VUE_APP_DANAPAY_API_SECRET,
  },
});

instance.interceptors.request.use((req) => {
  const token = localStorage.getItem("user:key");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  }
  return req;
});

instance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response.data || response);
  },
  (error) => {
    const response = error.response || {};
    if (response.status === 401) {
      // send to login
      // eslint-disable-next-line no-unused-vars
      router.push("/login").catch((error) => {});
    }
    return Promise.reject(error);
  },
);

instance.setAuthenticationToken = (token) => {
  if (token) {
    instance.defaults.headers.common.Authorization = "Bearer " + token;
    storeJWTToken(token);
  } else {
    delete instance.defaults.headers.common.Authorization;
    store.user = null;
    removeJWTToken();
  }
};

export default instance;
